import { IContext } from "@src/context";
import { IProperty } from "./types";
import {
  fetchAllProperties,
  fetchAllParkingSpots,
} from "../SearchResult/propertiesFetcher/allProperties";
import { getFavoriteList } from "@src/utils/favorite";

export function fetchFavoritedProperties(
  context: IContext
): Promise<IProperty[]> {
  const favoriteList = getFavoriteList("apartment");

  return Promise.all([fetchAllProperties(context)]).then(
    ([originProperties]) => {
      const favoritedProperties = favoriteList
        .map((id) => {
          return originProperties.find(
            (property) => property.id?.toString() === id
          );
        })
        .filter((property) => property !== undefined) as IProperty[];

      return favoritedProperties;
    }
  );
}

export function fetchFavoritedParkingSpots(
  context: IContext
): Promise<IProperty[]> {
  const favoriteList = getFavoriteList("parking");

  return Promise.all([fetchAllParkingSpots(context)]).then(
    ([originParkingSpots]) => {
      const favoritedParkingSpots = favoriteList
        .map((id) => {
          return originParkingSpots.find(
            (parkingSpot) => parkingSpot.id?.toString() === id
          );
        })
        .filter((parkingSpot) => parkingSpot !== undefined) as IProperty[];

      return favoritedParkingSpots;
    }
  );
}
